<template>
  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="sim_task_info" parent="sim_task" >
    <tab id="info" :name="translate('sim_task.section.info')" :href="url+'/info'" >
      <Info
        :id="cur_id"
        :sim_task="sim_task_info"
        @update="get_sim_task"
      />
    </tab>

  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Sim Task: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/sim_task_list'}">
              To List Project
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Info from './Tabs/Info/Info.vue'

export default {
  name: 'SimTask',
  components: {
    Info,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'profile',
      sim_task_info: {},
    }
  },

  computed: {
    url () { return '/sim_task/' + this.$route.params.sim_task_id },
    cur_id () { return this.$route.params.sim_task_id },
    load () { return !this.sim_task_info?.task?.id }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'sim_task_section') {
        this.get_sim_task()
      }
    }
  },

  activated(){
    this.get_sim_task()
  },

  methods: {
    get_sim_task () {
      this.$http.simcard.getSimTaskInfo(this.$route.params.sim_task_id, (response) => {
        this.sim_task_info = response.data
      })
    }
  }
}

</script>
